<template>
  <section class="page-section">
        <!-- filter -->
        <div class="filter-region no-margin-top">
          <div class="filter-form">
            <el-form
              size="small"
              :inline="true"
              :model="filterForm"
              ref="filterForm"
            >
              <el-form-item label="ID：" prop="id">
                <el-input
                  v-model="filterForm.id"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号：" prop="mobile">
                <el-input
                  v-model="filterForm.mobile"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="呢称：" prop="name">
                <el-input
                  v-model="filterForm.name"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="顾客所属管家：" prop="serviceUserId">
                <el-select
                  v-model="filterForm.serviceUserId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.serviceUserName"
                    :value="item.serviceUserId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="顾客等级：" prop="userLevelId">
                <el-select
                  v-model="filterForm.userLevelId"
                  placeholder="请选择"
                  :loading="levelLoading"
                >
                  <template v-for="(row, rowIndex) in levelOptions">
                    <el-option
                      :label="row.levelName"
                      :value="row.id"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="状态：" prop="status">
                <el-select v-model="filterForm.status" placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="启用" value="0"></el-option>
                  <el-option label="停用" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button
                plain
                class="btn-reset"
                icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"
              ></el-button>
              <el-button
                type="primary"
                class="btn-search"
                @click="filterFormSubmit('filterForm')"
                :loading="tableLoading"
                >查询</el-button
              >
            </el-button-group>
          </div>
        </div>
        <el-button
          class="btn-add-block"
          type="primary"
          @click="pageNavigateToLevel"
          >顾客等级设置</el-button
        >

        <!-- table -->
        <div class="table-region" v-loading="tableLoading">
          <el-table size="small" :data="tableData" ref="multipleTable">
            <el-table-column label="ID">
              <template slot-scope="scope">
                <p>{{ scope.row.id }}</p>
              </template>
            </el-table-column>
            <el-table-column label="呢称">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column label="手机号">
              <template slot-scope="scope">
                <p>{{ scope.row.mobile }}</p>
              </template>
            </el-table-column>
            <el-table-column label="好友标签">
              <template slot-scope="scope">
                <p>{{ scope.row.tagName || "--" }}</p>
              </template>
            </el-table-column>
            <el-table-column label="顾客等级">
              <template slot-scope="scope">
                <p>LV{{ scope.row.userLevelId }}</p>
              </template>
            </el-table-column>
            <el-table-column label="好友来源">
              <template slot-scope="scope">
                <p>{{ scope.row.sourceName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="添加方式">
              <template slot-scope="scope">
                <p>{{ scope.row.addWayName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="专属管家">
              <template slot-scope="scope">
                <p>{{ scope.row.serviceUserName }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="下级顾客总数"
              sortable
              sort-by="distributorNum"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.distributorNum }}</p>
              </template>
            </el-table-column>
            <el-table-column label="添加好友时间" sortable sort-by="addTime">
              <template slot-scope="scope">
                <p>{{ formatTimestamp(scope.row.firstAddFriendTime) }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="首次登录时间"
              sortable
              sort-by="firstLoginTime"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.firstLoginTime }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="上次交易时间"
              sortable
              sort-by="lastBuyTime"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.lastBuyTime }}</p>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <el-popover
                  placement="left"
                  width="160"
                  v-model="scope.row.statusVisible"
                  popper-class="confirm-popover"
                >
                  <p>
                    确定{{
                      scope.row.status === 0 ? "停用" : "启用"
                    }}该顾客账号？
                  </p>
                  <div>
                    <el-button
                      size="small"
                      type="default"
                      plain
                      @click="scope.row.statusVisible = false"
                      >取消</el-button
                    >
                    <el-button
                      size="small"
                      type="primary"
                      :loading="statusLoading"
                      @click="handleSwitch(scope)"
                      >确定</el-button
                    >
                  </div>
                  <div
                    slot="reference"
                    class="switch-wrapper"
                    @click="handleSwitchClick"
                  >
                    <el-switch
                      :value="scope.row.status"
                      :inactive-value="1"
                      :active-value="0"
                      active-color="#43B034"
                      inactive-color="#D4D4DC"
                    />
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right" width="150">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="verificationSheet(scope.row)"
                  >券码核销</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="editCustomer(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="pageNavigateToUserUserDetail(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate"></div>
          <div class="pagination-wrap">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]"
              :pager-count="5"
              :current-page="page.current"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
            >
            </el-pagination>
          </div>
        </div>
        <!-- </div> -->
      
    <edit-customer
      :visible.sync="enterCustomerDialog"
      :customerData="customerData"
      @success="getList"
    ></edit-customer>
    <verification-sheet
      :visible.sync="verificationSheetDialog"
      :userId="userId"
    ></verification-sheet>
      </section>
</template>

<script>
import {
  userUserList,
  userUserUpdateStatus,
  userLevelList,
  list,
} from "@/common/api.js";
import EditCustomer from "./components/edit-customer.vue";
import VerificationSheet from "./components/verification-sheet.vue";

export default {
  components: {
    EditCustomer,
    VerificationSheet,
  },
  data() {
    return {
      filterForm: {
        id: "",
        name: "", // 姓名
        mobile: "", // 手机号
        userLevelId: null,
        status: "",
        serviceUserId: "",
      },
      options: [],
      tableData: [],
      tableLoading: false,
      page: {
        // 分页参数
        current: 1,
        size: 20,
        total: 0,
      },
      levelOptions: [],
      levelLoading: false,
      statusLoading: false,
      enterCustomerDialog: false, // 编辑顾客信息弹窗
      verificationSheetDialog: false, // 券码核销弹窗
      customerData: {
        id: 0, // 顾客id
        mobile: "",
        serviceUserId: 0, // 管家id
        serviceUserName: "", // 管家名字
        remake: "", // 备注
      },
      userId: "", // 顾客信息
      options: [],
      tableHeight: 400,
    };
  },
  methods: {
    getManagerList() {
      list()
        .then((res) => {
          if (res.data.length === 0) {
            this.$message.error("暂无管家信息");
            return;
          }
          this.options = res.data;
        })
        .catch(() => {
          this.$message.error("获取管家列表失败");
        });
    },
    /**
     * [getLevelList description] 获取列表
     * @return {[type]} [description]
     */
    getLevelList: function () {
      this.levelLoading = true;

      let params = {};

      userLevelList(params)
        .then((res) => {
          let { code, data, msg } = res;

          if (code == 0) {
            this.levelLoading = false;

            this.levelOptions = data || [];
            this.levelOptions.unshift({
              id: null,
              levelName: "全部",
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error("服务器异常");
        });
    },
    // 提交筛选表单
    filterFormSubmit: function () {
      this.page.current = 1;
      this.getList();
    },
    // 重置筛选表单
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.tableLoading = true;

      let params = {
        id: this.filterForm.id,
        name: this.filterForm.name,
        mobile: this.filterForm.mobile,
        status:
          this.filterForm.status === ""
            ? null
            : parseFloat(this.filterForm.status),
        userLevelId: this.filterForm.userLevelId,
        serviceUserId: this.filterForm.serviceUserId,
        current: this.page.current,
        size: this.page.size,
      };

      userUserList(params)
        .then((res) => {
          this.tableLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            let dataArr = data.records || [];
            this.page.total = data.total;
            this.tableData = dataArr;
            this.$nextTick(() => {
              const scrollContainer = document.querySelector(".app-container");
              if (scrollContainer) {
                scrollContainer.scrollTop = 0;
              }
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.$message.error("服务器异常");
        });
    },
    /**
     * [pageNavigateToLevel description] 顾客等级设置
     * @return {[type]}          [description]
     */
    pageNavigateToLevel: function () {
      this.$router.push({ path: "/agent/user/level" });
    },
    editCustomer(e) {
      this.enterCustomerDialog = true;
      this.customerData = {
        id: e.id,
        mobile: e.mobile || "",
        serviceUserId: e.serviceUserId || "",
        serviceUserName: e.serviceUserName || "",
        remake: e.remake || "",
        agentCompanyId: e.agentCompanyId || "",
        agentCompanyName: e.agentCompanyName || "",
      };
    },
    verificationSheet(e) {
      this.userId = e.id;
      this.verificationSheetDialog = true;
    },
    /**
     * [pageNavigateToUserUserDetail description] 查看用户详情
     * @return {[type]}          [description]
     */
    pageNavigateToUserUserDetail: function (row) {
      this.$router.push({ path: "/agent/user/detail", query: { id: row.id } });
    },
    /**
     * [handleSwitch description] 启用和禁用
     * @param  {[Object]} scope [description] 当前操作行
     * @return {[type]}          [description]
     */
    handleSwitch: function (scope) {
      let param = {
        userId: scope.row.id,
        status: scope.row.status === 1 ? 0 : 1,
      };

      this.updateStatus(param);
    },
    updateStatus: function (param) {
      this.statusLoading = true;
      userUserUpdateStatus(param)
        .then((res) => {
          let { code, msg } = res;
          this.statusLoading = false;
          if (code == 0) {
            this.$message.success("操作成功");
            this.getList();
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.statusLoading = false;
          this.$message.error("服务器异常");
        });
    },
    handleSwitchClick(e) {
      e.stopPropagation();
    },
    /**
     * [formatTimestamp description] 格式化秒级时间戳为 yyyy-mm-dd hh:mm:ss
     * @param  {[Number]} timestamp [description] 秒级时间戳
     * @return {[String]}           [description] 格式化后的时间字符串
     */
    formatTimestamp(timestamp) {
      if (!timestamp) return "--";
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    /**
     * [calcTableHeight description] 动态计算表格高度
     * @return {[type]} [description]
     */
    calcTableHeight() {
      // 废除表格强制高计算
      // const tableRegion = document.querySelector('.table-region')
      // const tableFooter = document.querySelector('.table-footer')
      // if (tableRegion) {
      //   const regionHeight = tableRegion.clientHeight
      //   const footerHeight = tableFooter ? tableFooter.offsetHeight : 0
      //   this.tableHeight = regionHeight - footerHeight - 20 // 20px 为边距
      //   this.$nextTick(() => {
      //     this.$refs.multipleTable && this.$refs.multipleTable.doLayout()
      //   })
      // }
    },
  },
  mounted: function () {
    this.getList();
    this.getManagerList();
    this.getLevelList();
    // this.$nextTick(() => {
    //   this.calcTableHeight()
    // })
    // window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.calcTableHeight)
  },
};
</script>

<style lang="scss" scoped>
// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;

.btn-add-block {
  flex-shrink: 0;
  align-self: flex-start;
}

// }

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;
  justify-content: space-between;

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        & + .el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.table-region {
  // flex: 1; // 占用剩余高度
  // display: flex;
  // flex-direction: column;
  // overflow: hidden;
  margin-bottom: 50px;

  ::v-deep .el-table {
    // flex: 1;

    &::before {
      height: 0;
    }
  }

  // 修复固定列头部背景色不一致问题
  ::v-deep .el-table__fixed-right-patch {
    background-color: #f6f7f9; // $colorTitleBg 的值，或者直接写变量如果可用
    border-bottom: none;
  }

  ::v-deep .el-table__fixed-right {
    thead th {
      background-color: #f6f7f9;
      border-bottom: none;
    }

    &::before {
      height: 0;
    }
  }

  // .table-footer {
  //   flex-shrink: 0; // 分页区域不压缩，保持固定高度
  // }
}

.info-item {
  margin-left: 20px;

  &:first-child {
    margin-left: 0;
  }
}

.cursor-pointer {
  cursor: pointer;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 30px !important;
}
</style>
